<template>
<div id="index">
  <div class="backMusic">
    <audio controls ref="backgroundMusic" loop autoplay hidden>
      <source :src="musicBack">
    </audio>
    <button @click="backMusicPause('backgroundMusic')">♬</button>
  </div>

  <div class="carouselSlide">
      <b-carousel id="carousel1"
                  style="text-shadow: 1px 1px 2px #333;"
                  indicators
                  background="#ababab"
                  :interval="8000"
                  v-model="slide"
                  @sliding-start="onSlideStart"
                  @sliding-end="onSlideEnd"
      >

        <b-carousel-slide>
          <img slot="img" class="d-block img-fluid w-100" width="1024" height="480"
               src="@/../static/image/indexCover01.png" alt="image slot">
               <h1>
                 {{$t('avatamsaka.index.slider01')}}
               </h1>
        </b-carousel-slide>

        <b-carousel-slide>
          <img slot="img" class="d-block img-fluid w-100" width="1024" height="480"
               src="@/../static/image/indexCover02.png" alt="image slot">
               <h1>
                 {{$t('avatamsaka.index.slider02')}}
               </h1>
        </b-carousel-slide>


      </b-carousel>

    </div>

    <div class="sectionFunc">

    <div class="func">
      <router-link to="/avatamsaka/chooseArticle">
        <i class="fa fa-microphone"></i>
        <br/>
        {{$t('avatamsaka.versions.articleRead')}}
      </router-link>
    </div>

    <div class="func">
      <router-link to="/avatamsaka/chooseContra">
        <i class='fab fa-readme'></i>
        <br/>
        {{$t('avatamsaka.contrast.title')}}
      </router-link>
    </div>

    <div class="func">
      <router-link to="/avatamsaka/chooseCategory">
        <i class="material-icons">library_books</i>
        <br/>
        {{$t('avatamsaka.category.title')}}
      </router-link>
    </div>

    <div class="func">
      <router-link to="/avatamsaka/chooseIntro">
        <i class='fas fa-scroll'></i>
        <br/>
        {{$t('avatamsaka.intro.title')}}
      </router-link>
    </div>

    <div class="func">
      <router-link to="/avatamsaka/download">
        <i class="fa fa-download"></i>
        <br/>
        {{$t('avatamsaka.download.title')}}
      </router-link>
    </div>

</div>

    <div class="sectionIntro">
      <div class="sectionBack">
      </div>
      <div class="introBook">
        <img src="@/../static/image/content/indexBook.png" />
      </div>
      <div class="introContent">
        <h2>{{$t('avatamsaka.index.bookTitle')}}</h2>
        <!-- <button @click="musicPause('01')" class="musicButton">
          <i class='fas fa-volume-up'></i>
        </button> -->

        <p>
          {{$t('avatamsaka.index.bookIntro')}}
          <router-link to="/avatamsaka/avatamsaka">
            ▶ {{$t('avatamsaka.index.area01link')}}
          </router-link>
          <br/>
          <router-link to="/avatamsaka/PurePractices">
            ▶ {{$t('avatamsaka.sutra01.title')}}
          </router-link>
        </p>
        <!-- <audio controls ref="musicArea01" :src="musicArea01" hidden></audio> -->

      </div>
    </div>

    <div class="areaTitle">
      <div class="caption">
        <span>{{$t('avatamsaka.intro.title')}}</span>
      </div>
    </div>

    <div class="sectionVersion">
      <div class="version">
        <img src="@/../static/image/content/indexIntroArea03.jpg" />
        <div class="title">
          <span @click="getVersionPath(3)">
            {{$t('avatamsaka.versions.version', {
              'noticeType': $t(`avatamsaka.versions.type[2].text`)
            })}}
          </span>
        </div>
      </div>
      <div class="version">
        <img src="@/../static/image/content/indexIntroArea02.jpg" />
        <div class="title">
          <span @click="getVersionPath(2)">
            {{$t('avatamsaka.versions.version', {
              'noticeType': $t(`avatamsaka.versions.type[1].text`)
            })}}
          </span>
        </div>
      </div>
      <div class="version">
        <img src="@/../static/image/content/indexIntroArea01.jpg" />
        <div class="title">
          <span @click="getVersionPath(1)">
            {{$t('avatamsaka.versions.version', {
              'noticeType': $t(`avatamsaka.versions.type[0].text`)
            })}}
          </span>
        </div>
      </div>
    </div>
    <div class="sectionResearch">
      <div class="researcherContent">
        <h2>{{$t('avatamsaka.index.aboutIntroTitle')}}</h2>
        <!-- <button @click="musicPause('02')" class="musicButton">
          <i class='fas fa-volume-up'></i>
        </button> -->
        <p>
          {{$t('avatamsaka.index.aboutIntroContent')}}
          <br/>
          <router-link to="/avatamsaka/about">▶ {{$t('avatamsaka.index.area02link')}}</router-link>
          <br/>
        </p>
        <!-- <audio controls ref="musicArea02" :src="musicArea02" hidden></audio> -->
      </div>
      <img src="@/../static/image/content/indexResercher.png" />
    </div>

    <div class="sectionVideo">
      <div class="videoWrapper">
          <iframe :src="videoURL" frameborder="0" allowfullscreen></iframe>
      </div>

    </div>

</div>
</template>

<script>
export default {
  name: 'avatamsakaIndex',
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  watch: {
    musicArea01() {
      this.$refs.musicArea01.src = this.musicArea01;
    },
  },
  computed: {
    musicBack() {
      return '/static/mp3/蓮花池Pic01.mp3';
      // return '/static/mp3/香水蓮花PIC02.mp3';
    },
    musicArea01() {
      const url = this.musicFile('01');
      return url;
    },
    musicArea02() {
      const url = this.musicFile('02');
      return url;
    },
    videoURL() {
      let url = '';
      switch (this.$i18n.locale) {
        case 'bo':
          url = 'https://www.youtube.com/embed/MtQ6ubqLYns';
          break;
        default:
          url += 'https://www.youtube.com/embed/mrL6fyZEN_o';
          break;
      }
      return url;
    },
  },
  methods: {
    musicFile(num) {
      let url = '/static/mp3/music-';
      switch (this.$i18n.locale) {
        case 'bo':
          url += `bo_area${num}.mp3`;
          break;
        case 'en':
          url += `en_area${num}.mp3`;
          break;
        default:
          url += `tw_area${num}.mp3`;
          break;
      }
      return url;
    },
    musicPause(nowClick) {
      this.$refs.backgroundMusic.volume = '0.3';
      const other = nowClick === '01' ? 'musicArea02' : 'musicArea01';
      const now = `musicArea${nowClick}`;
      if (this.$refs[now].paused) {
        this.$refs[now].play();
        this.$refs[other].pause();
        this.$refs[other].currentTime = 0;
      } else {
        this.$refs[now].pause();
        this.$refs.backgroundMusic.volume = '1';
      }
    },
    backMusicPause(now) {
      if (this.$refs[now].paused) {
        this.$refs[now].play();
      } else {
        this.$refs[now].pause();
      }
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    getVersionPath(versionId) {
      this.$router.push({
        name: 'intro',
        params: {
          vid: versionId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#index {

button:hover {
  cursor: pointer;
}

.areaTitle {
  margin-top: 10em;
  margin-bottom: 4em;
  border-top: 3px solid #eed85e;
  background: #0d685c;
  height: 0.4em;
  display: flex;
  align-items: center;
  .caption {
    font-size: 1.5em;
    display: flex;
    align-items: center;
    justify-content: center;
      span {
        font-weight: bolder;
        font-size: 1em;
        align-self: center;
        background: #ffffff;
        border-left: #ffffff solid 1.1em;
        border-right: #ffffff solid 1.1em;
      }
    padding: 10px;
    flex: 1;
  }
  @media (max-width: 768px) {
    height: auto;
    margin-top: 3em;
    background: transparent;
    border: none;
    margin-bottom: 0px;
    .caption {
      span {
        font-size: 0.9em;
      }
    }
  }
}

.backMusic {
  position: sticky;
  float: right;
  top: 4em;
  height: 0px;
  z-index: 3;
  button {
    margin-top: 2em;
    padding: 0.3em;
    padding-left: 0.6em;
    background: rgba(2, 39, 10, 0.3);
    border: solid 4px #ffffff9d;
    border-right: none;
    color: #ffffff;
    font-weight: bolder;
  }
}
h2 {
  float: left;
}
p {
  clear: both;
}
.musicButton {
  padding: 0px;
  margin-left: 1.2em;
  background: none;
  border: none;
  float: left;
  @media (max-width: 768px) {
    clear: both;
  }
}

.sectionFunc {
  background: #505444;
  color: #ffffff;
  display: flex;
  padding: 5em 2em;
  .func {
    flex: 1;
    font-size: 1.2em;
    .fa-scroll, .fa-download {
      clear: both;
      padding-bottom: 22px;
      font-size: 3.5em;
    }
    i {
      font-size: 3.5em;
      padding-bottom: 15px;
    }
    a {
      color: #ffffff;
      font-size: 1em;
      text-decoration: none;
    }
    :hover {
      text-shadow: 0px 0px 6px #fff;
    }
  }
  @media (max-width: 768px) {
    padding: 1em;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: 0px;
    padding-top: 2em;
    .func {
      min-width: 33.33%;
      max-width: 33.33%;
      padding-bottom: 1em;
      .fa-scroll, .fa-download {
        clear: both;
        padding-bottom: 0.2em;
        padding-top: 0.1em;
        font-size: 2.2em;
      }
      i {
        font-size: 2.5em;
        padding-bottom: 0px;
      }
      a {
        color: #ffffff;
        font-size: 0.7em;
        text-decoration: none;
      }
    }
  }
}

.sectionIntro {
    display: flex;
    position: relative;


  .sectionBack {
    position: absolute;
    width: 100%;
    height: 0;
    border-top: 500px solid #505444;
    border-right: 100vw solid transparent;
  }

  .introBook {
    position: sticky;
    flex: 1;
    padding-top: 20px;
    margin: 40px;
    img {
      max-height: 450px;
    }
  }
  .introContent {
    .refBtn {
      clear: both;
      float: right;
    }
    p {
      a {
        display: block;
        line-height: 0.3em;
      }
    }
    position: sticky;
    flex: 2;
    background-color: rgba(231, 241, 233, 0.8);
    margin: 40px;
    margin-top: 60px;
    margin-right: 60px;
    padding: 20px;
    text-align: left;
    @media (max-width: 768px) {
        h2 {
          text-align: center;
        }
        button {
          display: block;
          margin: 0 auto;
        }
    }
  }

  @media (max-width: 768px) {

      display: block;
      flex-direction: row;

      .introBook, .introContent {
        clear: both;
        display: block;
        width: 100%;
        flex: none;
        margin: 0px;
        padding: 40px;
      }

      .introBook {
        position: relative;
        margin: 0;
        img {
          width: 100%;
          max-height: none;
        }
      }
  }
}

.sectionVersion {
  background: rgb(177, 155, 105);
  margin-top: 2em;
  margin-bottom: 10em;
  display: flex;
  .version {
    flex: 1;
    position: relative;
    .title {
      background: rgba(255, 255, 255, 0.56);
      text-align: center;
      height: 25%;
      min-height: 50px;
      padding: 5px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      font-size: 1.3em;
      font-weight: bolder;
      display: flex;
      span {
        align-self: center;
        width: 100%;
        text-shadow: 0px 0px 10px rgba(#ffffff, 0.88),
        0px 0px 10px rgba(#ffffff, 0.88),
        0px 0px 10px rgba(#ffffff, 0.88),
        0px 0px 10px rgba(#ffffff, 0.88), 0px 0px 10px rgba(#ffffff, 0.2);

      }
      span:hover{
        cursor: pointer;
      }
    }
    img {
      width: 100%;
    }
    @media (max-width: 768px) {
      border-bottom: 1em solid #ffffff;
    }
  }

  @media (max-width: 768px) {
    display: block;
    margin-top: 0px;
    margin-bottom: 0px;
    .version {
      width: 100%;
      padding: 30px;
    }
  }

}

.sectionResearch {
  position: relative;
  margin: 60px;
  margin-right: 0px;
  display: flex;
  text-align: left;
  margin-top: 200px;

  .researcherContent {
    align-self: center;
    padding: 3em;
    flex: 3;
    @media (max-width: 1024px) and (min-width: 768px) {
      padding: 0px;
    }
  }

  img {
    flex: 1;
  }


    @media (max-width: 768px) {
      margin: 0px;

      display: block;
      flex-direction: row;

      .researcherContent {
        padding: 1em;
      }

      img {
        width: 100%;
      }

    }


}

.sectionVideo {
  padding: 10%;
  .videoWrapper {
    position: relative;
    padding-bottom: 56.25%;
    overflow: hidden;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}

#carousel1 {
  .carousel-caption {
    top: 0;
    bottom: auto;
  }
  @media (max-width: 768px) {
    h1 {
      font-size: 0.8em;
      margin-bottom: 0px;
    }
  }
}


h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

@media (max-width: 768px) {
  h2 {
    font-size: 1.3em;
  }
}

}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue